export default __webpack_public_path__ + "static/media/1.ec71d504.jpg";